import React from 'react';
import classNames from 'classnames';
import DatePicker from 'react-date-picker';

const isValidDate = (d) => d instanceof Date && !Number.isNaN(d.getTime());

const parseDate = (value) => {
  if (!value) return null;

  // ya viene Date
  if (isValidDate(value)) return value;

  // viene string
  if (typeof value === 'string') {
    const s = value.trim();

    // evita parciales tipo "__/__/____"
    if (!s || s.includes('_')) return null;

    // ISO yyyy-mm-dd
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
      const y = +iso[1], m = +iso[2], d = +iso[3];
      const dt = new Date(y, m - 1, d);
      if (dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d) return dt;
      return null;
    }

    // dd/mm/yyyy
    const latam = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (latam) {
      const d = +latam[1], m = +latam[2], y = +latam[3];
      const dt = new Date(y, m - 1, d);
      if (dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d) return dt;
      return null;
    }

    return null;
  }

  return null;
};

export default class renderDate extends React.Component {
  render() {
    const { input, name, className, meta: { touched, error } } = this.props;
    const invalid = touched && error;

    const safeValue = parseDate(input.value);

    return (
      <div className={classNames('', className, { 'is-invalid': invalid })}>
        <DatePicker
          name={name}
          locale="es-GT"
          format="dd/MM/y"
          value={safeValue}              // <-- NUNCA Invalid Date
          onChange={(value) => {
            // si viene Invalid Date o null, guardamos null
            input.onChange(isValidDate(value) ? value : null);
          }}
          clearIcon={null}
        />

        {invalid && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  }
}

